import React from 'react';
import { Bars } from 'react-loader-spinner';
import './SmallLoader.css'; // Optional, for custom styling

const SmallLoader = () => {
    return (
        <div className="small-loader">
            <Bars 
                height="80" 
                width="80" 
                color="#DB9E30" 
                ariaLabel="bars-loading"
                visible={true}
            />
        </div>
    );
}

export default SmallLoader;
